
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ProjectWizardContactPersonSelector.html?raw';
import '../../../moreCore/UI/GenericDialog/GenericDialog';
import { EvBookingCopyForm } from "../../_loadingHelpers/VAMv2";
import { VAM2types } from "../../_loadingHelpers/VAMv2Types";
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import "../../../moreCore/UI/EntityBased/HintBox/HintBox"
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import GenericEntityView from '../../../moreCore/UI/EntityBased/EntityView/GenericEntityView';
class ProjectWizardContactPersonSelector extends compose(_StatefulSection, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    contactPersonHintBox: MdsLax<InstanceType<typeof HintBox>>;
    entityViewButton: {
        name: string,
        node: HTMLElement,
        callback: Function,
        iconNode: HTMLElement;
    };


    protected afterSetData() {
        
        let data = this.sourceData as VAM2types.EvProject_PromoterEntity;

        if (data?.ref_address) {
            this.contactPersonHintBox.addAdditionalRequestParameter("promoterAddressId", data.ref_address.ID);
        } else {
            this.contactPersonHintBox.emptyAdditionalRequestParams();
        }
        //if (!data.ref_contact_person) this.contactPersonHintBox.setValue(null);
        this.disableNode(this.contactPersonHintBox.domNode, data && data.ref_address ? false : true);
    }

    setNullValue() {
        this.setAttributeValue("ref_contact_person", null);
    }

    enableEntityViewButton(enable: boolean) {
        if (enable) {
            this.entityViewButton = this.contactPersonHintBox.addInlineButton(lang.hitch(this, this._onClickEntityViewButton), "entityView", "fas fa-eye");
        } else {
            this.contactPersonHintBox.removeInlineButton("entityView");
            this.entityViewButton = null;
        }
    }

    private _onClickEntityViewButton() {
        let entity = this.contactPersonHintBox.getValue("entity");
        if (!entity) return;
        let entityView = new GenericEntityView();
        entityView.setup(entity.ID, entity.Classname, entity.gDisp_Name_Firstname, "gDisp_Name_Firstname");
    }

    protected onDirtyChange(currentState: boolean) {

    }

    protected _onChanged(key: string, value: any) {
        //this.setStylesBasedOnData(); // bissl extrem? wird bei jeder kleinen Änderung aufgerufen
    }

    private _onChanged_ContactPerson(key: string, newValue: VAM2types.EvProject_PromoterEntity, oldValue: any) {
        if (newValue) {
           
        }
        let currentValue = this.contactPersonHintBox.getValue("entity");
        if (this.entityViewButton) this.disableNode(this.entityViewButton.node, currentValue ? false : true);
    }

    //private setupHintboxes() {
    //    this.roomInput.addInlineButton(lang.hitch(this, this._onClick_OpenRoomSED));
    //}

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        //this.setupHintboxes();

        this.addOnchanged("___root", lang.hitch(this, this._onChanged_ContactPerson));
        this.disableNode(this.contactPersonHintBox.domNode, true);
        this.contactPersonHintBox.on("change", lang.hitch(this, this._onChanged_ContactPerson))
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ProjectWizardContactPersonSelector);